import styled from "styled-components";

export const StyledAssignmentHeader = styled.div`
    padding: 16px;
`;

export const StyledTypeContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-right: 10px;
    margin-bottom: 4px;

    svg {
        font-size: 24px;
        object-fit: contain;
    }
`;
